import { request, Variables } from "graphql-request";
import {loginRequest} from "../../config/authConfig";
import {IMsalContext} from "@azure/msal-react";
import {APIEndpoint} from "../../config/backendConfig";

interface Props {
	query: string,
	variables?: Variables,
	instance: IMsalContext["instance"]
	accounts: IMsalContext["accounts"]
}

export async function apiRequest(props: Props) {
	const {query,
		variables,
		instance,
		accounts
	} = props;
	if (!accounts[0]) {
		await instance.loginRedirect();
	}

	const response = await instance.acquireTokenSilent({
		...loginRequest,
		account: accounts[0]
	});

	const requestHeader = new Headers();

	const bearer = `Bearer ${response?.accessToken}`;
	requestHeader.append("Authorization", bearer);
	if (bearer) {
		requestHeader.append("X-MS-CLIENT-PRINCIPAL", btoa(JSON.stringify({
			"identityProvider": "AAD",
			"userRoles": ["authenticated"]
		})));
		requestHeader.append("X-MS-API-ROLE", "authenticated");
	}
	return request(
		APIEndpoint,
		query,
		{...variables, "inUserSID": accounts[0].localAccountId },
		requestHeader);
}
